import { render, staticRenderFns } from "./Import2.vue?vue&type=template&id=10c51fa2&"
import script from "./Import2.vue?vue&type=script&lang=js&"
export * from "./Import2.vue?vue&type=script&lang=js&"
import style0 from "./Import2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports